import tickMark from "../../assets/img/svg/tick-mark.svg";
import closeMark from "../../assets/img/svg/close-mark.svg";
import userPlusBlue from '../../assets/img/svg/user-plus-blue.svg';
import pinkUser from '../../assets/img/svg/pink-user.svg';
import usersGreen from '../../assets/img/svg/users-green.svg';
import calendar from '../../assets/img/svg/calendar.svg';
import blankPurpleCalendar from '../../assets/img/svg/blank-purple-calendar.svg';
import calendarTickOrange from '../../assets/img/svg/calendar-tick-orange.svg';
import crossRed from '../../assets/img/svg/cross-red.svg';
import adminOrange from "../../assets/img/svg/admin-orange.svg";
import phoneWhite from "../../assets/img/svg/phone-white.svg";
import tabletOrange from "../../assets/img/svg/tablet-orange.svg";
import desktopWhite from "../../assets/img/svg/desktop-white.svg";
import routes from "../../Views/Pages/routes/routesConfig";
import crossLight from "../../assets/img/svg/cross-light.svg";
import greenTickIcon from "../../assets/img/svg/tick-mark.svg";
import { convertTo12HourFormat, customFromNow, formatDateTime, formatDuration, formatFeedbackType, formatTimeTo12HourFormat, getCurrentUser, getTimeRequestStatusLabel, hasPermission, isAdminUser } from "../../services/commonService";
import translation from "../../utils/translation";
import { dateFnsLocalizer } from "react-big-calendar";
import { format, parse, startOfWeek, getDay } from "date-fns";
import dayjs from "dayjs";
import enUS from "date-fns/locale/en-US";

const locales = { "en-US": enUS };

const calendarLocalizer = dateFnsLocalizer({
  format: (date, formatStr) =>
    format(date, formatStr
      .replace('YYYY', 'yyyy')
      .replace('YY', 'yy')
      .replace('DD', 'dd')
      .replace('D', 'd')
      .replace('A', 'aa')
      .replace('a', 'aa')
    ),
  parse,
  startOfWeek,
  getDay,
  locales,
});

const bigCalendarFormats = {
  timeGutterFormat: (date) => calendarLocalizer.format(date, 'h A'),
  eventTimeRangeFormat: (range) => {
    return `${ dayjs(range.start).format('h:mm A') }`;
  }
};

export const interviewStagesConfig = [
  {
    id: "1",
    className: "invited",
    countKey: "invited_stages_count",
    translationKey: 'key_invited'
  },
  {
    id: "2",
    className: "applied",
    countKey: "applied_stages_count",
    translationKey: 'key_applied'
  },
  {
    id: "3",
    className: "Matched",
    countKey: "matched_stages_count",
    translationKey: 'key_matched'
  },
  {
    id: "4",
    className: "Pending",
    countKey: "pending_stages_count",
    translationKey: 'key_pending'
  },
  {
    id: "5",
    className: "Upcoming",
    countKey: "upcoming_stages_count",
    translationKey: 'key_upcoming'
  },
  {
    id: "6",
    className: "Completed",
    countKey: "completed_stages_count",
    translationKey: 'key_completed'
  },
  {
    id: "10",
    className: "Cancelled",
    countKey: "cancelled_stages_count",
    translationKey: 'key_cancelled'
  }
];

const profileConfig = [
  { label: "Role", value: "Helper" },
  { label: "Gender", value: "Female" },
  { label: "Nationality", value: "Filipino" },
  { label: "Date of Birth", value: "12/12/1999" },
  { label: "Height", value: "155 cm" },
  { label: "Weight", value: "47 kg" },
  { label: "Religion", value: "Christian" },
  { label: "Age", value: "24" },
];
const predefinedDateRanges = [
  { label: "Custom Date Range", value: "custom", key: "key_custom_date_range" },
  { label: "Yesterday", value: "yesterday", key: "key_yesterday" },
  { label: "Last 7 days", value: "last_7_days", key: "key_last_7_days" },
  { label: "Last 30 days", value: "last_30_days", key: "key_last_30_days" },
  { label: "Last 60 days", value: "last_60_days", key: "key_last_60_days" },
  { label: "Last 90 days", value: "last_90_days", key: "key_last_90_days" },
  { label: "This Month", value: "this_month", key: "key_this_month" },
  { label: "Last Month", value: "last_month", key: "key_last_month" },
  { label: "This Quarter", value: "this_quarter", key: "key_this_quarter" },
  { label: "Year to Date", value: "year_to_date", key: "key_year_to_date" },
  { label: "Last Year", value: "last_year", key: "key_last_year" },
];
const familyBackgroundConfig = [
  { label: "Marital Status", value: "Married" },
  { label: "No of Children", value: "3" },
  { label: "Age of eldest child", value: "?" },
  { label: "No. of siblings", value: "4" },
];

const languageAndEducationConfig = [
  { label: "Languages", value: "English, Chinese" },
  { label: "Special Course", value: "Bachelor of Nursing, Bachelor in Education" },
  { label: "Education", value: "College, University" },
  { label: "Institution", value: "University of Phillipens" },
];
const workExperienceConfig = [
  { label: "Role", value: "Helper" },
  { label: "Start Date - End Date", value: "July 2018 - June 2020" },
  { label: "Work Location", value: "Hong Kong" },
  { label: "District", value: "Wanchai" },
  { label: "Employer Nationality", value: "Chinese" },
  { label: "Language Spoken", value: "Cantonese" },
  { label: "Family Size", value: "4" },
  { label: "Size of Home", value: "500 Sq Ft" },
  { label: "Reason for Leaving", value: "Terminated Due to Employer (Financial Problem)" }
];
const expectationsConfig = [
  { label: "Care for newborn baby", value: "Yes" },
  { label: "Care for someone with disability", value: "No" },
  { label: "Share room with co-helper", value: "Yes" },
  { label: "Share work with another helper", value: "Consider" },
  { label: "Day off preference", value: "Thursday" },
  { label: "Can interview on", value: "Sun, Mon, Tues" },
  { label: "Reference Letter", value: "Available" }
];

const spouseConfig = [
  { label: "Name", value: "Akash Singh" }
];

const previousContractConfig = [
  { label: "Previous Agency", value: "-" },
  { label: "Previous Partner Agency", value: "-" }
]

const documentStatusConfig = {
  provided: { text: 'provided to pt', icon: tickMark, className: 'text-success' },
  not_provided: { text: 'not provided to pt', icon: closeMark, className: 'text-danger' },
  received: { text: 'received', icon: tickMark, className: 'text-success' },
  not_received: { text: 'not received', icon: closeMark, className: 'text-danger' },
  never_applied: { text: 'never applied before', icon: null, className: '' }
};

const documentsConfig = [
  { id: 1, name: 'Passport (Previous)', status: documentStatusConfig.never_applied, date: '' },
  { id: 2, name: 'Indonesian ID', status: documentStatusConfig.provided, date: '12/10/2024' },
  { id: 3, name: 'Birth Certificate', status: documentStatusConfig.not_provided, date: '' },
  { id: 4, name: 'Education Certificate', status: documentStatusConfig.provided, date: '12/10/2024' },
  { id: 5, name: 'Family Certificate', status: documentStatusConfig.provided, date: '12/10/2024' },
  { id: 6, name: 'Family Permission Letter', status: documentStatusConfig.not_received, date: '' },
  { id: 7, name: 'Reference Letter', status: documentStatusConfig.not_received, date: '' },
  { id: 8, name: 'Letter of Inheritance', status: documentStatusConfig.received, date: '12/10/2024' },
];
export const masterLinksConfig = (permissions) => {
  return [
    { id: 0, name: 'key_agency', link: 'agencies', isPermitted: permissions?.canViewAgency },
    { id: 1, name: 'key_branch_office', link: 'branches', isPermitted: permissions?.canViewBranch },
  ];
}
export const peopleLinksConfig = (permission, configurationPermission) => {
  return [
    { id: 0, name: 'key_role', link: 'roles', isPermitted: permission?.canViewRole },
    { id: 1, name: 'key_users', link: 'users', isPermitted: permission?.canViewUser },
    { id: 2, name: 'key_manual_update_leaves', link: 'manual-update-leaves', isPermitted: configurationPermission?.canManualUpdateLeave },
    { id: 3, name: 'key_view_leave_ledger', link: 'view-leave-ledger', isPermitted: configurationPermission?.canViewLeaveLedger },
  ];
}
export const configurationLinksConfig = (permission) => {
  return [
    { id: 0, name: 'key_holidays', link: 'holidays', isPermitted: permission?.canViewHoliday },
    { id: 1, name: 'key_leave_policy', link: 'leave-policy', isPermitted: permission?.canViewLeavePolicy },
    { id: 2, name: 'key_doop', link: 'days-of-operation', isPermitted: permission?.canViewDoop },
    { id: 3, name: 'key_shifts', link: 'shift-codes', isPermitted: permission?.canViewShiftCode },
    { id: 6, name: 'key_templates', link: 'templates', isPermitted: true },
    { id: 8, name: 'key_price_list', link: 'price-list', isPermitted: true },
    { id: 9, name: 'key_medical_clinic', link: 'medical-list', isPermitted: true },
    { id: 10, name: 'key_prompt_manager', link: 'prompt-manager', isPermitted: isAdminUser() }
  ]
}

const colorsConfig = {
  holiday: {
    backgroundColor: 'rgba(242, 231, 255, 1)',
    border: '1px solid rgba(242, 231, 255, 1)',
    color: 'rgba(144, 32, 255, 1)',
  },
  shiftStart: {
    backgroundColor: '#E5FAEA',
    border: '1px solid #E5FAEA',
    color: '#20893C',
  },
  shiftEnd: {
    backgroundColor: 'rgba(255, 227, 228, 1)',
    border: '1px solid rgba(255, 227, 228, 1)',
    color: 'rgba(255, 89, 99, 1)',
  },
  weekOff: {
    backgroundColor: 'rgba(255, 248, 225, 1)',
    border: '1px solid rgba(255, 248, 225, 1)',
    color: 'rgba(255, 202, 40, 1)',
  },
  workingDay: {
    backgroundColor: 'rgba(229, 250, 234, 1)',
    border: '1px solid rgba(229, 250, 234, 1)',
    color: 'rgba(32, 137, 60, 1)',
  }
};

const daysOfWeek = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

const statusMappingConfig = {
  1: 'Open',
  2: 'Review',
  3: 'Hold',
  4: 'Expiring',
  5: 'Expired',
  6: 'Closed',
  7: 'Draft'
};

const jobStatusNameMapping = {
  1: { key: 'key_open', label: 'Open', className: 'open' },
  2: { key: 'key_in_review', label: 'In Review', className: 'in-review' },
  3: { key: 'key_hold', label: 'Hold', className: 'hold' },
  4: { key: 'key_expiring', label: 'Expiring', className: 'expiring' },
  5: { key: 'key_expired', label: 'Expired', className: 'expired' },
  6: { key: 'key_closed', label: 'Closed', className: 'closed' },
  7: { key: 'key_draft', label: 'Draft', className: 'draft' },
  8: { key: 'key_banned', label: 'Banned', className: 'banned' },
  9: { key: 'key_deleted', label: 'Deleted', className: 'deleted' },
};

const invoiceStatusNameMapping = {
  1: { label: 'Pending Paid', className: 'pending-paid' },
  2: { label: 'Reservation Fee', className: 'reservation_fee' },
  3: { label: 'Partial Payment', className: 'partial-payment' },
  4: { label: 'Paid', className: 'paid' },
  5: { label: 'Unsettled', className: 'unsettled' },
  6: { label: 'Refunded', className: 'refunded' },
  7: { label: 'Exchange', className: 'exchange' },
  8: { label: 'Bad Debt', className: 'bad-debt' },
  9: { label: 'Void', className: 'void' },
};

const invoiceStatusNameMappingByName = {
  'Pending Paid': { label: 'Pending Paid', className: 'pending-paid' },
  'Reservation Fee': { label: 'Reservation Fee', className: 'reservation_fee' },
  'Partial Pay': { label: 'Partial Payment', className: 'partial-payment' },
  'Paid': { label: 'Paid', className: 'paid' },
  'Unsettled': { label: 'Unsettled', className: 'unsettled' },
  'Refunded': { label: 'Refunded', className: 'refunded' },
  'Exchange': { label: 'Exchange', className: 'exchange' },
  'Bad debt': { label: 'Bad debt', className: 'bad-debt' },
  'Void': { label: 'Void', className: 'void' },
};

const paymentMethodsListMapped = {
  'credit_card': { label: 'Credit Card' },
  'union_pay': { label: 'Union Pay' },
  'bank_in': { label: 'Bank In' },
  'cash': { label: 'Cash' },
  'cheque': { label: 'Cheque' }
};

const invoiceStatusIdMapping = {
  1: { label: 'Paid', className: 'paid' },
  2: { label: 'Pending Paid', className: 'pending-paid' },
  3: { label: 'Partial Pay', className: 'partial-payment' },
  4: { label: 'Reservation Fee', className: 'reservation_fee' },
  5: { label: 'Unsettled', className: 'unsettled' },
  6: { label: 'Void', className: 'void' },
  7: { label: 'Bad debt', className: 'bad-debt' },
  8: { label: 'Refunded', className: 'refunded' },
  9: { label: 'Refunded', className: 'paid' },
  10: { label: 'Exchange', className: 'exchange' },
  11: { label: 'Exchange', className: 'paid' }
};

const WorkerStatusNameMapping = {
  1: { id: 1, label: 'Incomplete', className: 'incomplete', key: 'in_incomplete', translationKey: 'key_incomplete' },
  2: { id: 2, label: 'In Review', className: 'in-review', key: 'in_review', translationKey: 'key_in_review' },
  3: { id: 3, label: 'Available', className: 'available', key: 'available', translationKey: 'key_available' },
  4: { id: 4, label: 'Employed', className: 'employed', key: 'employed', translationKey: 'key_employed' },
  5: { id: 5, label: 'Suspended', className: 'suspended', key: 'suspended', translationKey: 'key_suspended' },
  6: { id: 6, label: 'Banned', className: 'banned', key: 'banned', translationKey: 'key_banned' },
  7: { id: 7, label: 'Hold', className: 'hold', key: 'hold', translationKey: 'key_hold' },
  8: { id: 8, label: 'Private', className: 'private', key: 'private', translationKey: 'key_private' },
  9: { id: 9, label: 'Partner Pending', className: 'partner-pending', key: 'partner_pending', translationKey: 'key_partner_pending' },
  12: { id: 12, label: 'Holiday Mode', className: 'holiday-mode', key: 'holiday_mode', translationKey: 'key_holiday_mode' },
  13: { id: 13, label: 'Hired', className: 'hired', key: 'hired', translationKey: 'key_hired' },
  10: { id: 10, label: 'Withdraw(Partner)', className: 'withdraw_partner', key: 'withdraw_partner', translationKey: 'key_withdraw_partner' },
};

const WorkerDocumentStatusNameMapping = {
  'in_complete': { label: 'Incomplete', className: 'blue', icon: crossLight },
  'in_review': { label: 'In Review', className: 'worker-in-review' },
  'action_required': { label: 'Action Required', className: 'text-purple' },
  'verified': { label: 'Verified', className: 'expired', icon: greenTickIcon },
  'uploaded': { label: 'Uploaded', className: 'yellow' },
};

const titlesConfig = {
  holiday: "Holiday",
  shiftStart: "Shift Start",
  shiftEnd: "Shift End",
  weekOff: "Week Off",
  workingDay: "Working Day"
};

const membersCountConfig = [
  { value: 0, label: '0' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
];

const changeOwnerTitles = {
  bulk: 'Bulk Change CS',
  individual: 'Change Individual CS',
};


const choiceMap = {
  1: "Yes",
  0: "No",
  null: "No Preference",
};

const workerStatusConfig = {
  ALL: { label: 'key_all', id: null },
  LOCAL: { label: 'key_local', id: 1 },
  OVERSEAS: { label: 'key_overseas', id: 2 },
  DECLINED: { label: 'key_decline', id: 3 },
  NOT_INTERESTED: { label: 'key_not_interested', id: 6 },
  NO_SHOW: { label: 'key_no_show', id: 7 },
  ARCHIVED: { label: 'key_archived', id: 8 },
}


const profileStatus = {
  'Incomplete': '<span className="text-danger">Incomplete</span>',
  'Available': '<span className="text-primary">Available</span>',
  'Active': '<span className="text-success">Incomplete</span>',
  'Inactive': ' <span className="text-warning">Incomplete</span>',
  'Paused': '<span className="text-danger">Incomplete</span>',
  'Suspended': '<span className="text-danger">Incomplete</span>',
  'Banned': '<span className="text-danger">Incomplete</span>',
  'Draft': '<span className="text-danger">Incomplete</span>',
  'Employed': '<span className="text-primary">Incomplete</span>',
  'Hold': '<span className="text-warning">Incomplete</span>',
  'Archived': '<span className="text-dark">Incomplete</span>',
  'Cancelled': '<span className="text-danger">Incomplete</span>',
  'Not Visible': '<span className="text-danger">Incomplete</span>',
  'In Review': '<span className="text-warning">Incomplete</span>',
  'Less Active': '<span className="text-secondary">Incomplete</span>'
};

const getMembersCountConfig = (memberCountInfo) => {
  const data = [
    { category: 'key_adults', no: memberCountInfo?.adult_count },
    { category: 'key_age_below_5', no: memberCountInfo.child_age_below_5_count },
    { category: 'key_age_5_to_18', no: memberCountInfo.child_age_5_8_count },
    { category: 'key_expecting_babies', no: memberCountInfo.expecting_baby_count },
    { category: 'key_special_needs', no: memberCountInfo.special_needs_count },
  ];
  return data;
}

const legendsConfig = [
  { label: 'key_invited', icon: userPlusBlue, className: 'invited' },
  { label: 'key_applied', icon: pinkUser, className: 'applied' },
  { label: 'key_matched', icon: usersGreen, className: 'matched' },
  { label: 'key_interview_pending', icon: blankPurpleCalendar, className: 'pending' },
  { label: 'key_interview_upcoming', icon: calendar, className: 'upcoming' },
  { label: 'key_interview_completed', icon: calendarTickOrange, className: 'completed' },
  { label: 'key_cancelled', icon: crossRed, className: 'cancelled' },
];
const dutiesConfig = [
  { id: 1, label: "Elderly Care" },
  { id: 2, label: "Baby Care" },
  { id: 3, label: "Pet Care" },
];
const ChannelConfig = {
  WHATSAPP: 'Whatsapp',
  WECHAT: 'Wechat',
  SMS: 'SMS'
};
const jobStatusConfig = {
  ALL: { label: 'key_all', id: null },
  OPEN: { label: 'key_open', id: 1 },
  IN_REVIEW: { label: 'key_in_review', id: 2 },
  HOLD: { label: 'key_hold', id: 3 },
  CLOSED: { label: 'key_closed', id: 6 },
  DRAFT: { label: 'key_draft', id: 7 },
  OPEN_EXPIRING: { label: 'key_open_expiring', id: 4 },
};
const deviceIconClasses = {
  1: 'bg-green border-0',
  2: 'bg-blue border-0',
  3: 'bg-transparent',
  4: '',
};

const deviceIcons = {
  1: desktopWhite,
  2: phoneWhite,
  3: tabletOrange,
  4: adminOrange,
};
const localWorkerDashboard2ColumnsConfig = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_contract_status"),
  t("key_contract_visa_expiry"),
  t("key_interpreter"),
];

const philppinesWorkerDashboard2ColumnsConfig = ({ t }) => [
  t("key_worker_name"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_job_offer_statistics"),
  t("key_passport"),
  t("key_overseas_exp"),
  t("key_interpreter"),
];
const availableFilipinoWorkerColumnsConfigDashboard1Local = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_job_offer_statistics"),
  t("key_contract_status"),
  t("key_contract_visa_expiry"),
  t("key_interpreter"),
];

const workerColumnsConfigDashboard2Oversease = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_interpreter")
];

const filipinoWorkerColumnsConfigDashboard2Oversease = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_e_registration"),
  t("key_peos"),
  t("key_tesda"),
  t("key_assign_partner"),
  t("key_interpreter")
];
const availableFilipinoWorkerColumnsConfigDashboard1Oversease = ({ t }) => [
  t("key_worker_name"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_job_offer_statistics"),
  t("key_passport"),
  t("key_overseas_exp"),
  t("key_interpreter"),
];
const defaultWorkerColumnsConfig = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status")
];
const defaultWorkerColumnsConfigDashBoard2 = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status"),
  t("key_onboarding") + " 1",
  t("key_onboarding") + " 2"
];
const localWorkerColumnsConfig = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_contract_status"),
  t("key_contract_visa_expiry"),
  t("key_interpreter")
];
const availableWorkerColumnsConfig = ({ t }) => [
  t("key_worker_name"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_job_offer_statistics"),
  t("key_contract_status"),
  t("key_contract_visa_expiry"),
  t("key_interpreter"),
];
const philppinesWorkerColumnsConfig = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_e_registration"),
  t("key_peos"),
  t("key_tesda"),
  t("key_assign_partner"),
  t("key_contract_status"),
  t("key_contract_visa_expiry"),
  t("key_interpreter"),
];
const indonesianWorkerColumnsConfig = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_passport"),
  t("key_indonesian_id"),
  t("key_birth_certificate"),
  t("key_family_certificate"),
  t("key_education_certificate"),
  t("key_assign_partner"),
  t("key_medical"),
  t("key_submit_documents"),
  t("key_training_certificate"),
  t("key_labour_id"),
  t("key_interpreter"),
];
const indoWorkerColumnsConfigDashboard2Oversease = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_passport"),
  t("key_indonesian_id"),
  t("key_birth_certificate"),
  t("key_family_certificate"),
  t("key_education_certificate"),
  t("key_assign_partner"),
  t("key_medical"),
  t("key_submit_documents"),
  t("key_training_certificate"),
  t("key_labour_id"),
  t("key_interpreter"),
];

const allOverseaseIndoWorkerColumnsConfig = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_assign_partner"),
  t("key_pt"),
  t("key_interpreter"),
];

const availableLocalWorkerColumnsConfigDashboard1 = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_contract_status"),
  t("key_contract_visa_expiry"),
  t("key_interpreter"),
];
const defaultWorkerOptionConfig = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status")
];
const workerKababOptionsConfig = (type, allItems, isFieldsToDisplay, filtersData = "") => {
  let subItems = allItems;
  if (type == "default") {
    subItems = defaultWorkerOptionConfig;
  }
  const items = [];
  if (isFieldsToDisplay) {
    items.unshift({
      id: 1,
      name: translation('key_select_fields_to_display'),
      type: 0,
      subItem: subItems,
    })
  }
  if (filtersData !== "") {
    if (filtersData?.profile_status === "dashboard_1" && filtersData?.branch_id_checkin && filtersData?.branch_id_checkin.length > 0 && filtersData?.branch_id_checkin[0] != "") {
      items.push(
        {
          id: 2,
          name: translation('key_open_checkin_qr_code'),
          type: 1,
          subItem: [],
        },
        {
          id: 3,
          name: translation('key_replace_checkin_qr_code'),
          type: 2,
          subItem: [],
        },
        {
          id: 4,
          name: translation('key_checkout_selected_worker'),
          type: 3,
          subItem: [],
        }
      );
    }
  }
  return items;
  /*if (isFieldsToDisplay) {
    return [
      {
        id: 1,
        name: "Select Fields to Display",
        type: 0,
        subItem: subItems,
      },
      { id: 2, name: "Bulk Change Interpreter", type: 1 },
      { id: 3, name: "Change Individual Interpreter", type: 2 },
    ];
  } else {
    return [
      { id: 1, name: "Bulk Change Interpreter", type: 1 },
      { id: 2, name: "Change Individual Interpreter", type: 2 },
    ];
  }*/
}
const employerColumnsConfig = [
  "Employer Name",
  "Chinese Name",
  "HKID",
  "Mobile",
  "Email",
  "Latest Job Offer",
  "JO Status",
  "Latest Contract",
  "CS",
];

const employerColumnsConfigTrans = ({ t }) => {
  return [
    t("key_employer_name"),
    t("key_chinese_names"),
    t("key_hkid"),
    t("key_mobile"),
    t("key_email"),
    t("key_latest_job_offer"),
    t("key_jo_status"),
    t("key_latest_contract"),
    t("key_cs"),
  ];
};
const employerColumnsConfigTransDuplicate = ({ t }) => {
  return [
    t("key_employer_name"),
    t("key_chinese_name"),
    t("key_hkid"),
    t("key_mobile"),
    t("key_email"),
    t("key_latest_job_offer"),
    t("key_jo_status"),
    t("key_latest_contract"),
    t("key_cs"),
    t("key_duplicate_reason"),
  ];
};
const empKababOptionsConfig = (isFieldsToDisplay) => {
  const items = [
    // { id: 2, name: translation('key_bulk_change_owner'), type: 1 },
    { id: 3, name: translation('key_change_individual_owner'), type: 2 },
  ];
  if (isFieldsToDisplay) {
    items.unshift({
      id: 1,
      name: translation('key_select_fields_to_display'),
      type: 0,
      subItem: [
        translation('key_employer_name'),
        translation('key_chinese_names'),
        translation('key_hkid'),
        translation('key_mobile'),
        translation('key_email'),
        translation('key_latest_job_offer'),
        translation('key_jo_status'),
        translation('key_latest_contract'),
        translation('key_cs'),
      ],
    },)
  }
  return items;
}
const jobofferColumnsConfig = [
  "Employer Name",
  "Type",
  "JO Ref",
  "JO Status",
  "Days Open",
  "Expected Start Date",
  "Views",
  "Apply %",
  "Stage Details",
  "CS",
];

const jobofferColumnsConfigTrans = ({ t }) => {
  return [
    t("key_employer_name"),
    t("key_type"),
    t("key_jo_ref"),
    t("key_jo_status"),
    t("key_days_open"),
    t("key_headline_english"),
    t("key_expected_start_date"),
    t("key_views"),
    t("key_apply_percent"),
    t("key_stage_details"),
    t("key_cs"),
  ];
};

const partnerColumnsConfigTrans = ({ t }) => {
  return [
    t("key_name"),
    t("key_worker_status"),
    t("key_updated"),
    t("key_biodata"),
    t("key_photo"),
    t("key_passport"),
    t("key_medical"),
    t("key_training_certificate"),
    t("key_labor_id"),
    t("key_details"),
    t("key_onboarding") + t(" 1"),
    t("key_onboarding") + t(" 2"),
    t("key_partner")
  ];
};



const processingColumnsConfig = [
  "Name",
  "Delay",
  "Contract",
  "Pre Departure",
  "Medical",
  "Consulate",
  "Immigration",
  "VISA",
  "Insurance",
  "Deployment",
];

const processingColumnsConfigTrans = ({ t }) => {
  return [
    t("key_name"),
    t("key_delay"),
    t("key_contract"),
    t("key_pre_departure"),
    t("key_medical"),
    t("key_consulate"),
    t("key_immigration"),
    t("key_visa"),
    t("key_insurance"),
    t("key_deployment"),
  ];
};

const kababOptionsProcessingConfig = [
  {
    id: 1,
    name: "Select Fields to Display",
    type: 0,
    subItem: [
      translation("key_name"),
      translation("key_delay"),
      translation("key_contract"),
      translation("key_pre_departure"),
      translation("key_medical"),
      translation("key_consulate"),
      translation("key_immigration"),
      translation("key_visa"),
      translation("key_insurance"),
      translation("key_deployment"),
    ],
  },
];

const insuranceColumnsConfigTrans = ({ t }) => {
  return [
    t("key_effective_date"),
    t("key_insurance_id"),
    t("key_status"),
    t("key_employer_name"),
    t("key_worker_name"),
    t("key_type"),
    t("key_policy"),
    t("key_invoice_no"),
  ];
};

const insuranceColumnsConfig = [
  "Effective Date",
  "Insurance ID",
  "Status",
  "Employer Name",
  "Worker Name",
  "Type",
  "Policy",
  "Invoice No",
];

const kababOptionsInsuranceConfig = [
  {
    id: 1,
    name: "Select Fields to Display",
    type: 0,
    subItem: insuranceColumnsConfig,
  },
];

const insuranceColumnsConfigTranslate = ({ translation }) => {
  return [
    translation("key_effective_date"),
    translation("key_insurance_id"),
    translation("key_status"),
    translation("key_employer_name"),
    translation("key_worker_name"),
    translation("key_type"),
    translation("key_policy"),
    translation("key_invoice_no"),
  ];
};

const kababOptionsInsuranceConfigTrans = ({ translation }) => {
  return [
    {
      id: 1,
      name: translation('key_select_fields_to_display'),
      type: 0,
      subItem: insuranceColumnsConfigTranslate({ translation }),
    }
  ];
};

const kababOptionsConfig = (isFieldsToDisplay) => {
  // const items = [
  //   { id: 2, name: translation('key_bulk_change_cs'), type: 1 },
  // ];
  const items = [];
  if (isFieldsToDisplay) {
    items.unshift({
      id: 1,
      name: translation('key_select_fields_to_display'),
      type: 0,
      subItem: [
        translation('key_employer_name'),
        translation('key_type'),
        translation('key_jo_ref'),
        translation('key_jo_status'),
        translation('key_days_open'),
        translation('key_headline_english'),
        translation('key_expected_start_date'),
        translation('key_views'),
        translation('key_apply_percent'),
        translation('key_stage_details'),
        translation('key_cs'),
      ],
    })
  }
  return items;
}

const invoiceColumnsConfig = ({ translation }) => {
  return [
    translation("key_invoice_status"),
    translation("key_payment"),
    translation("key_staff"),
    translation("key_ref_no"),
    translation("key_date"),
    translation("key_employer_name"),
    translation("key_worker_name"),
    translation("key_code"),
    translation("key_total"),
    translation("key_paid"),
    translation("key_unsettled"),
    translation("key_refunded"),
  ];
};

const invoiceColumnsConfigTrans = ({ t }) => {
  return [
    t("key_invoice_status"),
    t("key_payment"),
    t("key_staff"),
    t("key_ref_no"),
    t("key_date"),
    t("key_employer_name"),
    t("key_worker_name"),
    t("key_code"),
    t("key_total"),
    t("key_paid"),
    t("key_unsettled"),
    t("key_refunded"),
  ];
};

const invoiceOptionsConfig = ({ translation }) => {
  return [
    {
      id: 1,
      name: translation('key_select_fields_to_display'),
      type: 0,
      subItem: invoiceColumnsConfig({ translation }),
    }
  ];
};


const preferenceOptionsConfig = [
  { id: 1, name: 'Yes', translationKey: 'key_yes' },
  { id: 0, name: 'No', translationKey: 'key_no' },
];
const yesNoConfig = [
  { id: 1, name: 'Yes', translationKey: 'key_yes' },
  { id: 0, name: 'No', translationKey: 'key_no' },
];
const jobStageStatus = {
  INVITED: 1,
  APPLIED: 2,
  MATCHED: 3,
  PENDING: 4,
  UPCOMING: 5,
  COMPLETED: 6,
  CANCELLED: 10
};

const jobStageLabels = {
  [jobStageStatus.INVITED]: "Invited interview",
  [jobStageStatus.APPLIED]: "Applied interview",
  [jobStageStatus.MATCHED]: "Matched interview",
  [jobStageStatus.PENDING]: "Pending interview",
  [jobStageStatus.UPCOMING]: "Upcoming interview",
  [jobStageStatus.COMPLETED]: "Completed interview",
  [jobStageStatus.CANCELLED]: "Cancelled interview"
};
const reportsConfig = [
  {
    title: 'key_job_offer',
    description: 'key_job_report_description',
    link: routes.jobOfferReport,
    permissionKey: 'jo_report'
  },
  {
    title: 'key_interview',
    description: 'key_interview_report_description',
    link: routes.interviewReport,
    permissionKey: 'interview_report'
  },
  {
    title: 'key_feedback',
    description: 'key_feedback_report_description',
    link: routes.feedbackReport,
    permissionKey: 'feedback_report'
  },
  {
    title: 'key_insurance',
    description: 'key_insurance_report_description',
    link: routes.insuranceReport,
    permissionKey: 'insurance_report'
  },
  {
    title: 'key_contract',
    description: 'key_contract_report_description',
    link: routes.contractReport,
    permissionKey: 'contract_report'
  },
];

const hrmsReportsConfig = [
  {
    title: 'key_session_history',
    description: 'key_session_history_report_description',
    link: routes.sessionHistoryReport,
    permissionKey: 'session_history_report'
  },
  {
    title: 'key_schedule_compliance',
    description: 'key_schedule_compliance_report_description',
    link: routes.scheduleComplianceReport,
    permissionKey: 'schedule_compliance_report'
  },
  {
    title: 'key_time_request',
    description: 'key_time_request_report_description',
    link: routes.timeRequestReport,
    permissionKey: 'time_request_report'
  },
  {
    title: 'key_leave_history',
    description: 'key_leave_history_report_description',
    link: routes.leaveHistoryReport,
    permissionKey: 'time_credit_report'
  },
  {
    title: 'key_time_credit',
    description: 'key_time_credit_report_description',
    link: routes.timeEntryReport,
    permissionKey: 'applied_leave_history_report'
  },
];

const getNavConfig = ({ t, permissionList, isAdmin }) => {

  const staffType = getCurrentUser()?.data?.staff?.staff_type;
  const isJoGlobalScreen = hasPermission(permissionList, 'jo', 'jo_global_list') &&
    hasPermission(permissionList, 'jo', 'jo_access');
  const isWorkerGlobalScreen = staffType === 'internal' ?
    hasPermission(permissionList, 'worker', 'worker_access') :
    hasPermission(permissionList, 'partner_worker', 'partner_worker_access');

  const isEmployerGlobalScreen = (hasPermission(permissionList, 'employer', 'employer_global_list') &&
    hasPermission(permissionList, 'employer', 'employer_access'));
  const isPartnerGlobalScreen = (hasPermission(permissionList, 'partner', 'partner_global_list') &&
    hasPermission(permissionList, 'partner', 'partner_access'));

  const isInvoiceGlobalScreen = hasPermission(permissionList, 'invoice', 'invoice_access');
  const isReportGlobalScreen = hasPermission(permissionList, 'reports', 'report_access');
  const isInsuranceGlobalScreen = hasPermission(permissionList, 'insurance', 'insurance_access');
  const isContractGlobalScreen = hasPermission(permissionList, 'contract', 'contract_global_list');
  const isProcessingGlobalScreen = hasPermission(permissionList, 'processing', 'processing_global_list');
  const isProcessingContractGlobalScreen = hasPermission(permissionList, 'contract_processing', 'contract_processing_access');
  const allNavItems = [
    { path: routes.dashboard, label: t('key_home'), visible: isAdmin },
    { path: routes.jobOffers, label: t('key_job_offer'), visible: isAdmin || isJoGlobalScreen },
    { path: routes.employers, label: t('key_employer'), visible: isAdmin || isEmployerGlobalScreen },
    { path: routes.workers, label: t('key_worker'), visible: isAdmin || isWorkerGlobalScreen },
    { path: routes.contracts, label: t('key_contract'), visible: isAdmin || (isContractGlobalScreen && isProcessingContractGlobalScreen) },
    { path: routes.invoices, label: t('key_invoice'), visible: isAdmin || isInvoiceGlobalScreen },
    { path: routes.processings, label: t('key_processing'), visible: isAdmin || (isProcessingGlobalScreen && isProcessingContractGlobalScreen) },
    { path: routes.insurances, label: t('key_insurance'), visible: isAdmin || isInsuranceGlobalScreen },
    { path: routes.reports, label: t('key_report'), visible: isAdmin || isReportGlobalScreen },
    { path: routes.partner, label: t('key_partner'), visible: staffType === 'partner' && isPartnerGlobalScreen },
    { path: routes.settings, label: t('key_settings'), visible: isAdmin || staffType === 'internal' }
  ];

  return allNavItems.filter(item => item.visible);
};

const promotionTableDataConfig = [
  { promo_name: 'Promo Name 1', worker_type: 'Overseas, Local', apply_to: 'BGS, SW', branch_location: '9', start_date: '12/12/2023', end_date: 'Indefinite', value: '10%' },
  { promo_name: 'Promo Name 2', worker_type: 'Overseas, Local', apply_to: 'BGS, SW', branch_location: 'All', start_date: '12/12/2023', end_date: '12/12/2024', value: '$10000' },
  { promo_name: 'Promo Name 3', worker_type: 'Local', apply_to: 'LPF, LPT', branch_location: '5', start_date: '12/12/2023', end_date: '12/12/2024', value: '$13980' },
  { promo_name: 'Promo Name 4', worker_type: 'Overseas, Local', apply_to: 'LPF, LPT', branch_location: 'All', start_date: '12/12/2023', end_date: '12/12/2024', value: '$13980' }
];

const handleContract = ({ contract, t }) => {
  const staticDetailsConfig = [
    {
      title: t("key_category_type"),
      details: [
        { key: t("key_contract_category"), value: contract.contract_category_name },
        { key: t("key_nationality"), value: contract.worker_nationality_name },
        { key: t("key_type_internal"), value: contract.contract_type },
      ],
    },
    {
      title: t("key_passport_information"),
      details: [
        { key: t("key_passport_number"), value: contract.passport_number },
        { key: t("key_passport_expiry"), value: contract.passport_expiry_date },
      ],
    },
    {
      title: t("key_visa"),
      details: [
        { key: t("key_visa_reference_no"), value: contract.visa_reference_no },
        { key: t("key_visa_release"), value: contract.e_visa_payment_date },
        { key: t("key_visa_expiry"), value: contract.visa_expiry_date },
      ],
    },
    {
      title: t("key_insurance"),
      details: [
        { key: t("key_insurance_no"), value: "" },
        { key: t("key_insurance_expiry"), value: "" },
      ],
    },
    {
      title: t("key_contract"),
      details: [
        { key: t("key_contract_date"), value: contract.contract_date },
        { key: t("key_contract_no"), value: contract.contract_number },
        { key: t("key_start_date"), value: "" },
      ],
    },
    {
      title: t("key_contract"),
      details: [
        { key: t("key_requested_start"), value: contract.requested_start_date },
        { key: t("key_expected_start"), value: contract.expected_start_date },
      ],
    },
  ];
  return staticDetailsConfig;
}

const insuranceStatusIdMapping = {
  "submitted": { label: 'Submitted', className: 'submitted' },
  "active": { label: 'Active', className: 'insurance-active' },
  "add_coverage": { label: 'Add Coverage', className: 'insurance-submitted' },
  "renewal": { label: 'Renewal', className: 'insurance-submitted' },
  "endorsement": { label: 'Endorsement', className: 'insurance-submitted' },
  "expired": { label: 'Expired', className: 'insurance-expired' },
};

// const workerDuplicateOption = [
//   "Name",
//   "Profile Status",
//   "Duplicate Reason"
// ];

const workerDuplicateOption = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status"),
  t("key_duplicate_reason"),
];

const workerLocalDashboard1PhilOption = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_job_offer_statistics"),
  t("key_contract_status"),
  t("key_contract_visa_expiry"),
  t("key_interpreter"),
];

const workerOverseasDashboard1PhilOption = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_job_offer_statistics"),
  t("key_passport"),
  t("key_overseas_exp"),
  t("key_interpreter"),
  t("key_phone"),
];

const workerOverseasDashboard1IndoOption = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_job_offer_statistics"),
  t("key_passport"),
  t("key_overseas_exp"),
  t("key_interpreter"),
  t("key_phone"),
];

const workerLocalDashboard2Option = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_contract_status"),
  t("key_contract_visa_expiry"),
  t("key_interpreter"),
  t("key_phone"),
  t("key_onboarding") + " 1",
  t("key_onboarding") + " 2"
];

const workerOverseasDashboard2Option = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_interpreter"),
  t("key_phone"),
  t("key_onboarding") + " 1",
  t("key_onboarding") + " 2"
];

const workerLocalDashboard3Option = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_job_offer_statistics"),
  t("key_contract_status"),
  t("key_contract_end_date"),
  t("key_interpreter"),
  t("key_phone"),
];

const workerOverseasDashboard3Option = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_job_offer_statistics"),
  t("key_passport"),
  t("key_overseas_exp"),
  t("key_interpreter"),
  t("key_phone"),
];

const workerLocalDashboard4Option = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_contract_status"),
  t("key_contract_visa_expiry"),
  t("key_interpreter"),
  t("key_phone"),
];

const workerOverseasDashboard4Option = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_job_offer_statistics"),
  t("key_passport"),
  t("key_overseas_exp"),
  t("key_interpreter"),
  t("key_phone"),
];

const workerLocalDashboard5Option = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_contract_status"),
  t("key_contract_visa_expiry"),
  t("key_interpreter"),
  t("key_phone"),
];

const workerOverseasDashboard5Option = ({ t }) => [
  t("key_worker_name"),
  t("key_profile_status"),
  t("key_activity_status"),
  t("key_days_available"),
  t("key_views"),
  t("key_job_offer_statistics"),
  t("key_passport"),
  t("key_overseas_exp"),
  t("key_interpreter"),
  t("key_phone"),
];

const workerOverseasPhilipinoOption = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_assign_partner"),
  t("key_pt"),
  t("key_interpreter"),
  t("key_phone"),
];

const workerOverseasHasPhillNationalityDashboard2Option = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_e_registration"),
  t("key_peos"),
  t("key_tesda"),
  t("key_assign_partner"),
  t("key_phone"),
  t("key_interpreter"),
  t("key_onboarding") + " 1",
  t("key_onboarding") + " 2"
];

const workerOverseasHasIndonesianNationalityDashboard2Option = ({ t }) => [
  t("key_worker_name"),
  t("key_updated"),
  t("key_profile_status"),
  t("key_doc_upload"),
  t("key_delay"),
  t("key_biodata"),
  t("key_photo"),
  t("key_passport"),
  t("key_indonesian_id"),
  t("key_birth_certificate"),
  t("key_family_certificate"),
  t("key_education_certificate"),
  t("key_assign_pt"),
  t("key_pt"),
  t("key_medical"),
  t("key_submit_document"),
  t("key_training_certificate"),
  t("key_labour_id"),
  t("key_interpreter"),
  t("key_onboarding") + " 1",
  t("key_onboarding") + " 2"
];
const familyAndPetsCareMapping = {
  adult_count: 'employer_details.adult_count',
  baby_count: 'employer_details.baby_count',
  expecting_baby_count: 'employer_details.expecting_baby_count',
  expecting_baby_count_info: 'employer_details.expecting_baby_count_info',
  elderly_count: 'employer_details.elderly_count',
  child_count: 'employer_details.child_count',
  adult_count_info: 'employer_details.adult_count_info',
  baby_count_info: 'employer_details.baby_count_info',
  child_count_info: 'employer_details.child_count_info',
  elderly_count_info: 'employer_details.elderly_count_info',
};

const invoiceTypeMapping =
  [
    {
      id: "new",
      name: 'New',
      translationKey: 'key_new'
    },
    {
      id: "renew",
      name: 'Renew',
      translationKey: 'key_renew'
    }
  ];

const formatDateToDDMMYYYY = (date) => {
  return (date && dayjs(date).isValid()) ? dayjs(date).format('DD/MM/YYYY') : '';
}

const handleMainContract = (contract, t) => {
  const staticDetailsConfig = [
    {
      title: t("key_category_type", "Category Type"),
      details: [
        { key: t("key_contract_category", "Contract Category"), value: contract.contract_category_name },
        { key: t("key_nationality", "Nationality"), value: contract.worker_nationality_name },
        { key: t("key_type_internal", "Type Internal"), value: contract.contract_type },
      ],
    },
    {
      title: t("key_passport_information", "Passport Information"),
      details: [
        { key: t("key_passport_number", "Passport Number"), value: contract.passport_number },
        { key: t("key_passport_expiry", "Passport Expiry"), value: formatDateToDDMMYYYY(contract.passport_expiry_date) },
      ],
    },
    {
      title: t("key_visa", "Visa"),
      details: [
        { key: t("key_visa_reference_no", "Visa Reference No"), value: contract.visa_reference_no },
        { key: t("key_visa_release", "Visa Release"), value: formatDateToDDMMYYYY(contract.e_visa_payment_date) },
        { key: t("key_visa_expiry", "Visa Expiry"), value: formatDateToDDMMYYYY(contract.visa_expiry_date) },
      ],
    },
    {
      title: t("key_insurance", "Insurance"),
      details: [
        { key: t("key_insurance_no", "Insurance No"), value: "" },
        { key: t("key_insurance_expiry", "Insurance Expiry"), value: "" },
      ],
    },
    {
      title: t("key_contract", "Contract"),
      details: [
        { key: t("key_contract_date", "Contract Date"), value: formatDateToDDMMYYYY(contract.contract_date) },
        { key: t("key_contract_no", "Contract No"), value: contract.contract_number },
        { key: t("key_start_date", "Start Date"), value: "" },
      ],
    },
    {
      title: t("key_contract"),
      details: [
        { key: t("key_requested_start", "Requested Start"), value: formatDateToDDMMYYYY(contract.requested_start_date) },
        { key: t("key_arrival_date", "Arrival Date"), value: formatDateToDDMMYYYY(contract.arrival_date) },
        // { key: t("key_expected_start", "Expected Start"), value: formatDateToDDMMYYYY(contract.expected_start_date) }, //temporarily hidden as per request
      ],
    },
  ];
  return staticDetailsConfig;
}

const getInterviewStatusText = (status) => {
  switch (status) {
    case 1: return 'Invited';
    case 2: return 'Applied';
    case 3: return 'Matched';
    case 4: return 'Pending';
    case 5: return 'Upcoming';
    case 6: return 'Completed';
    case 10: return 'Cancelled';
    default: return 'N/A';
  }
};

const exportJobOffers = (jobOfferList) => {
  if (!jobOfferList || !Array.isArray(jobOfferList)) return [];

  return jobOfferList.map(row => ({
    'Job ID': row?.job_offer_reference_id || '-',
    'Employer ID': row?.employer_reference_id || '-',
    'Employer': row?.employer_name || '-',
    'CS': row?.cs_name || '-',
    'Job Title': row?.head_line || '-',
    'Job Role': row?.role_name || '-',
    'Branch Name': row?.branch_display_name || '-',
    'Created On': row?.created_at ? dayjs(row.created_at).format('DD MMM YYYY, hh:mm A') : '-',
    'Created By': row?.created_by_name || '-',
    'Expected Start Date': row?.start_date ? dayjs(row.start_date).format('DD MMM YYYY') : '-',
    'Approved On': row?.opening_date_time ? dayjs(row.opening_date_time).format('DD MMM YYYY, hh:mm A') : '-',
    'Expiry Date': row?.expiry_date ? dayjs(row.expiry_date).format('DD MMM YYYY') : '-',
    'Closed On': row?.closing_date_time ? dayjs(row.closing_date_time).format('DD MMM YYYY, hh:mm A') : '-',
    'Current Status': (row?.status && statusMappingConfig) ? statusMappingConfig[row.status] : row.status,
    'Workers Interacted': row?.views_count || '0',
    'Suggested': row?.suggested_count || '0',
    'Viewed': row?.views_count || '0',
    'Applied': row?.applied_count || '0',
    'Apply Percentage': row?.apply_percentage ? `${ row.apply_percentage }%` : '0%',
    'Matched': row?.matched_count || '0',
    'Interview Invited': row?.pending_interview_count || '0',
    'Interview Scheduled': row?.upcoming_interview_count || '0',
    'Interview Completed': row?.completed_interview_count || '0',
    'Interview Cancelled': row?.cancelled_interview_count || '0',
    'QR Interviews': row?.qr_interview_count || '0',
    'Instant Interviews': row?.instant_interview_count || '0',
    'Offer Extended': row?.offer_extended_count || '0',
  }));
}

const exportFeedbackReport = (feedbackList) => {
  if (!feedbackList || !Array.isArray(feedbackList)) return [];

  return feedbackList.map(item => ({
    'Timestamp': item.created_at || '-',
    'Rating': item.rating || '-',
    'Feedback For': formatFeedbackType(item?.feedback_type)?.label || '-',
    'Bug Reporter': item.feedback_user_name || '-',
    'User Type': item.created_by_type || '-',
    'Email': item['feedbackByUser.email'] || '-',
    'Phone': item['feedbackByUser.mobile_number'] || '-',
    'Feedback': item.comment || '-'
  }));
}

const exportInsuranceReport = (insuranceList) => {
  if (!insuranceList || !Array.isArray(insuranceList)) return [];

  return insuranceList.map((row) => ({
    'Insurance ID': row?.insurance_number || '-',
    'Policy Name': row?.policy_name || '-',
    'Employer ID': row?.employer_reference_id || '-',
    'Employer': row?.employer_name || '-',
    'Worker ID': row?.worker_reference_id || '-',
    'Worker': row?.worker_name || '-',
    'Branch': row?.branch_name || '-',
    'Type': row?.type || '-',
    'Policy No': row?.policy_number || '-',
    'Previous Policy Number': row?.previous_policy_number || '-',
    'Effective Date': row?.effective_date
      ? dayjs(row.effective_date).format('DD MMM YYYY')
      : '-',
    'Expiry Date': row?.expiry_date
      ? dayjs(row.expiry_date).format('DD MMM YYYY')
      : '-',
    'Invoice': row?.invoice_number || '-',
    'Additional Coverage': row?.coverage_details?.policy_name || '-',
    'Coverage Effective Date': (row?.coverage_details && row.coverage_details?.effective_date)
      ? dayjs(row.coverage_details.effective_date).format('DD MMM YYYY')
      : '-',
    'Coverage Expiry Date': (row?.coverage_details && row.coverage_details?.expiry_date)
      ? dayjs(row.coverage_details.expiry_date).format('DD MMM YYYY')
      : '-',
    'Coverage Invoice': row?.coverage_details?.invoice_number || '-',
  }));
};

const exportInterviews = (interviewList) => {
  return interviewList.map((interview) => ({
    "Interview ID": interview?.id || '-',
    "Interview Name": interview?.reference_id ? `JOID-Employer-Worker` : '-',
    "Employer ID": interview?.employer_reference_id || '-',
    "Employer Name": interview?.employer_fullname || '-',
    "Worker ID": interview?.worker_reference_id || '-',
    "Worker Name": interview?.worker_fullname || '-',
    "Job ID": interview?.reference_id || '-',
    "CS": interview?.cs_email || '-',
    "Interpreter": interview?.interpreter_email || '-',
    "GMeet Link": interview?.google_meet_link || '-',
    "Branch Name": interview?.branch_display_name || '-',
    "Original Interview Time": interview?.interview_date && interview?.interview_time
      ? `${ interview.interview_date } ${ interview.interview_time }`
      : '-',
    "Invited On": interview?.interview_invited_at || '-',
    "Declined On": interview?.interview_declined_at || '-',
    "Accepted On": interview?.interview_accepted_at || '-',
    "Reschedule Requested": interview?.is_reschedule ? 'Yes' : 'No',
    "Reschedule Requested Time": interview?.new_interview_date && interview?.new_interview_time
      ? `${ interview.new_interview_date } ${ interview.new_interview_time }`
      : '-',
    "Reschedule Accepted": interview?.is_reschedule
      ? (interview?.interview_accepted_at ? 'Yes' : 'No')
      : '-',
    "Updated Interview Time": interview?.new_interview_date && interview?.new_interview_time
      ? `${ interview.new_interview_date } ${ interview.new_interview_time }`
      : '-',
    "Interview Final Status": getInterviewStatusText(interview?.status),
    "Cancelled Reason": interview?.status === 4 ? interview?.no_show_flag || '-' : '-',
    "Report Comment": interview?.comment || '-',
    "Reported By": interview?.interview_report_marked_by_system
      ? 'System'
      : interview?.interview_report_marked_name || '-',
    "Reported Time": interview?.interview_report_marked_at || '-'
  }));
}

const exportContractReport = (contractReportList) => {
  if (!contractReportList || !Array.isArray(contractReportList)) return [];

  return contractReportList.map((row) => ({
    'Contract Ref': row?.contract_number || '-',
    'Invoice Ref No': row['contractInvoiceModel.invoice_number'] || '-',
    'Employer ID': row?.employer_reference_id || '-',
    'Employer': row?.employer_name || '-',
    'Worker ID': row?.worker_reference_id || '-',
    'Worker': row?.worker_name || '-',
    'Branch': row?.branch_name || '-',
    'CS': row?.cs_name || '-',
    'Type': row?.contract_type || '-',
    'Contract Category': row?.contract_category_name || '-',
    'Nationality': row?.worker_nationality_name || '-',
    'Contract Date': row?.created_at
      ? dayjs(row.created_at).format('DD MMM YYYY')
      : '-',
    'Visa Expiry': row['processingVisaDocumentModel.visa_expiry_date']
      ? dayjs(row['processingVisaDocumentModel.visa_expiry_date']).format('DD MMM YYYY')
      : '-',
    'Group': row?.group || '-',
    'Status': row?.contract_status_name || '-',
  }));
};

const exportSessionHistory = (userSessionHistory) => {
  return userSessionHistory.map((sessionHistory) => ({
    "Employee": sessionHistory?.name || '-',
    "Date": dayjs(sessionHistory?.login_date).format('DD MMM YYYY') || '-',
    "First Login": customFromNow(sessionHistory.first_login) || '-',
    "Last Login": customFromNow(sessionHistory.last_login) || '-',
    "Sessions": sessionHistory?.sessions || '-',
    "Average Session Duration": formatDuration(sessionHistory?.avg_seconds) || '-',
    "Total Session Duration": formatDuration(sessionHistory?.total_seconds) || '-',
  }));
}

const exportTimeRequestReport = (timeRequestHistory) => {
  return timeRequestHistory.map((request) => ({
    "Request Number": request?.request_number || '-',
    "Raised By": request?.raised_by || '-',
    "Raised On": request?.raised_on || '-',
    "Actioned By": request?.actioned_by || '-',
    "Actioned On": request?.actioned_on || '-',
    "For Date": request?.for_date || '-',
    "From": request?.from ? convertTo12HourFormat(request?.from) : '-',
    "To": request?.to ? convertTo12HourFormat(request?.to) : '-',
    "Asked Duration": request?.time_asked ? request?.time_asked : '-',
    "Approved Duration": request?.time_approved ? request?.time_approved : '-',
    "Status": getTimeRequestStatusLabel(parseInt(request?.status))?.label || '-',
  }));
}

const exportLeaveHistoryReport = (leaveHistory) => {
  return leaveHistory.map((leave) => ({
    "Applied By": leave?.applier_name || '-',
    "Raised On": leave.created_at ? formatDateTime(leave.created_at) : 'NA',
    "Actioned By": (leave.status == 1 || leave.status == 2) && leave.approver_name ? leave.approver_name : leave.status == 3 && leave.rejector_name ? leave.rejector_name : 'NA',
    "Actioned On": (leave.status == 1 || leave.status == 2) && leave.approved_at ? formatDateTime(leave.approved_at) : leave.status == 3 && leave.rejected_at ? formatDateTime(leave.rejected_at) : 'NA',
    "From": leave?.from_date || '-',
    "To": leave?.to_date || '-',
    "Days": leave?.duration || '-',
    "Status": (() => { const status = getTimeRequestStatusLabel(parseInt(leave?.status)); return status?.label })(),
  }));
}

const exportTimeEntryReport = (reportTimeEntry) => {
  const exportData = reportTimeEntry.map((entry) => ({
    "Log ID": entry.request_number || '-',
    "Created On": entry.raised_on ? `${ entry.raised_on } ${ entry.raised_on_time }` : '-',
    "Date For": entry.for_date || '-',
    "Start Time": entry.from ? `${ entry.for_date } ${ convertTo12HourFormat(entry.from) }` : '-',
    "Duration": entry.time_asked || '-',
    "Employee": entry.created_for || '-',
    "Added By": entry.raised_by || '-',
  }));
  return exportData;
}

const exportScheduleCompliance = (scheduleComplianceList) => {
  const exportData = scheduleComplianceList.map((entry) => ({
    "Employee": entry?.email || '-',
    "Date": entry?.date ? dayjs(entry.actual_login_date).format('DD MMM YYYY') : '-',
    "Day": entry?.login_day || '-',
    "Schedule Time In": entry?.shift_start_time ? formatTimeTo12HourFormat(entry.shift_start_time) : '-',
    "Actual Time In": entry?.actual_login_time ? formatTimeTo12HourFormat(entry.actual_login_time) : '-',
    "Time In Discrepancy (mins)": entry?.shift_start_diff || 0,
    "Schedule Time Out": entry?.shift_end_time ? formatTimeTo12HourFormat(entry.shift_end_time) : '-',
    "Actual Time Out": entry?.actual_logout_time ? formatTimeTo12HourFormat(entry.actual_logout_time) : '-',
    "Time Out Discrepancy (mins)": entry?.shift_end_diff || 0,
  }));
  return exportData;
}

const leavePolicyFormsConfig = {
  leave_policy_type: '',
  accrual_type: '',
  accrual_rate: '',
  effective_from_date_of_hire: '',
  carry_forward: 0,
  carry_forward_max: '',
  carry_forward_max_type: 'percentage',
  carry_forward_no_limit: false,
  encashment: 0,
  encashment_max: '',
  encashment_max_type: 'percentage',
  encashment_no_limit: false,
  threshold: '',
  expiry: 0,
  expiry_in_days: '',
  expiry_type: 'days',
  expiry_no_limit: false,
  status: 1
}

const viewUpdateTaskFormState = {
  task_name: '',
  task_description: '',
  task_date: '',
  task_time: ''
}

const paymentFollowUpFormState = {
  follow_up_note: '',
  due_date: '',
  due_time: ''
}

let configData = {
  interviewStagesConfig,
  workerLocalDashboard1PhilOption,
  workerOverseasDashboard1PhilOption,
  workerOverseasDashboard1IndoOption,
  workerLocalDashboard2Option,
  workerOverseasDashboard2Option,
  workerLocalDashboard3Option,
  workerOverseasDashboard3Option,
  workerLocalDashboard4Option,
  workerOverseasDashboard4Option,
  workerLocalDashboard5Option,
  workerOverseasDashboard5Option,
  workerOverseasPhilipinoOption,
  workerOverseasHasPhillNationalityDashboard2Option,
  workerOverseasHasIndonesianNationalityDashboard2Option,
  profileConfig,
  familyBackgroundConfig,
  languageAndEducationConfig,
  workExperienceConfig,
  expectationsConfig,
  spouseConfig,
  previousContractConfig,
  documentStatusConfig,
  documentsConfig,
  colorsConfig,
  titlesConfig,
  daysOfWeek,
  statusMappingConfig,
  invoiceStatusNameMapping,
  empKababOptionsConfig,
  kababOptionsProcessingConfig,
  changeOwnerTitles,
  membersCountConfig,
  workerStatusConfig,
  choiceMap,
  getMembersCountConfig,
  legendsConfig,
  dutiesConfig,
  ChannelConfig,
  jobStatusConfig,
  kababOptionsInsuranceConfig,
  insuranceColumnsConfig,
  jobStatusNameMapping,
  WorkerStatusNameMapping,
  WorkerDocumentStatusNameMapping,
  deviceIconClasses,
  deviceIcons,
  kababOptionsConfig,
  jobofferColumnsConfig,
  employerColumnsConfig,
  employerColumnsConfigTrans,
  partnerColumnsConfigTrans,
  localWorkerColumnsConfig,
  availableWorkerColumnsConfig,
  philppinesWorkerColumnsConfig,
  indonesianWorkerColumnsConfig,
  workerKababOptionsConfig,
  preferenceOptionsConfig,
  yesNoConfig,
  profileStatus,
  getNavConfig,
  insuranceColumnsConfigTrans,
  localWorkerDashboard2ColumnsConfig,
  philppinesWorkerDashboard2ColumnsConfig,
  availableFilipinoWorkerColumnsConfigDashboard1Local,
  defaultWorkerColumnsConfig,
  availableFilipinoWorkerColumnsConfigDashboard1Oversease,
  filipinoWorkerColumnsConfigDashboard2Oversease,
  workerColumnsConfigDashboard2Oversease,
  indoWorkerColumnsConfigDashboard2Oversease,
  allOverseaseIndoWorkerColumnsConfig,
  availableLocalWorkerColumnsConfigDashboard1,
  promotionTableDataConfig,
  invoiceStatusNameMappingByName,
  invoiceStatusIdMapping,
  paymentMethodsListMapped,
  processingColumnsConfig,
  processingColumnsConfigTrans,
  invoiceOptionsConfig,
  insuranceStatusIdMapping,
  familyAndPetsCareMapping,
  handleContract,
  invoiceTypeMapping,
  jobofferColumnsConfigTrans,
  invoiceColumnsConfigTrans,
  predefinedDateRanges,
  defaultWorkerColumnsConfigDashBoard2,
  jobStageStatus,
  jobStageLabels,
  workerDuplicateOption,
  employerColumnsConfigTransDuplicate,
  kababOptionsInsuranceConfigTrans,
  handleMainContract,
  bigCalendarFormats,
  calendarLocalizer,
  formatDateToDDMMYYYY,
  exportJobOffers,
  exportInterviews,
  exportContractReport,
  exportInsuranceReport,
  exportFeedbackReport,
  exportSessionHistory,
  exportTimeRequestReport,
  exportLeaveHistoryReport,
  exportTimeEntryReport,
  exportScheduleCompliance,
  leavePolicyFormsConfig,
  viewUpdateTaskFormState,
  paymentFollowUpFormState,
  reportsConfig,
  hrmsReportsConfig
}
export default configData;